// eslint-disable-next-line import/no-cycle
import router from '@/app/router';

export default function hasContract({ next, store }) {
	if (!store.state.contract) {
		return router.push('/');
	}
	return next();
	// if (!store.state.token) {
	// 	return next({ name: 'login' });
	// }
	// if (!store.state.hasActiveContract && store.state.token) {
	// 	return next({ name: 'home' });
	// }
	// return next();
	//
	// if (store.state.hasActiveContract) {
	// 	return next({ name: '' });
	// }
	// return;
	// // if (!store.state.hasActiveContract) {
	// // 	return next({ name: 'home' });
	// // }
	// // return next();
}
